// extracted by mini-css-extract-plugin
export default {"clickButton":"GoButton_clickButton__kmim7","goButton":"GoButton_goButton__0kmvk","title":"GoButton_title__Q+Jqn","icon":"GoButton_icon__C4JIK"};